var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2193_7090)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7184 0H19.8122C20.7574 0 21.5306 0.773292 21.5306 1.71846V26.2817C21.5306 27.2268 20.7574 28.0001 19.8122 28.0001H1.7184C0.773228 28.0001 0 27.2268 0 26.2817V1.71846C0 0.773292 0.773228 0 1.7184 0ZM9.35017 26.1348H12.1804V26.7571H9.35017V26.1348ZM10.0704 1.243C9.89855 1.243 9.75929 1.38233 9.75929 1.55414C9.75929 1.72596 9.89855 1.86528 10.0704 1.86528C10.2422 1.86528 10.3817 1.72596 10.3817 1.55414C10.3817 1.38233 10.2422 1.243 10.0704 1.243ZM11.4601 1.243C11.2882 1.243 11.1489 1.38233 11.1489 1.55414C11.1489 1.72596 11.2882 1.86528 11.4601 1.86528C11.6319 1.86528 11.7713 1.72596 11.7713 1.55414C11.7713 1.38233 11.6319 1.243 11.4601 1.243ZM1.81942 3.10822H19.7112V24.8919H1.81942V3.10822Z",
    fill: "#ADA0DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2193_7090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.362db65edb3003f8bfff96994a11af9f.svg";
export { ForwardRef as ReactComponent };